import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Header, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import { Admin } from '@/types/admin';
import { getFullName } from '@/utils/name';
import { pages } from '@/settings/pages';

type Props = {
  admin: Admin;
};

export const AccountMenu: FC<Props> = (props) => {
  const { admin } = props;
  const { t } = useTranslation();

  return (
    <StyledSegment>
      <GridWrapper>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <StyledHeader size="tiny">{t('models.admin.name')}</StyledHeader>
          </Grid.Column>
          <Grid.Column width={8}>
            <StyledAccountValue>
              {getFullName(admin.firstName, admin.lastName)}
              &nbsp; ({getFullName(admin.kanaFirstName, admin.kanaLastName)})
            </StyledAccountValue>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right" verticalAlign="middle">
            <StyledLink to={pages.account.name.edit} data-test="name-edit-link">
              <Icon name="edit" />
              {t('ui.action.change')}
            </StyledLink>
          </Grid.Column>
        </Grid.Row>
      </GridWrapper>
      <Divider hidden={true} />
      <GridWrapper>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <StyledHeader size="tiny">{t('ui.password.label')}</StyledHeader>
          </Grid.Column>
          <Grid.Column width={8}>
            <StyledAccountValue>****************</StyledAccountValue>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right" verticalAlign="middle">
            <StyledLink
              to={pages.account.password.edit}
              data-test="password-edit-link"
            >
              <Icon name="edit" />
              {t('ui.action.change')}
            </StyledLink>
          </Grid.Column>
        </Grid.Row>
      </GridWrapper>
      <Divider hidden={true} />
      <GridWrapper>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <StyledHeader size="tiny">{t('models.admin.email')}</StyledHeader>
          </Grid.Column>
          <Grid.Column width={8}>
            <StyledAccountValue>{admin.email}</StyledAccountValue>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right" />
        </Grid.Row>
      </GridWrapper>
    </StyledSegment>
  );
};

const StyledSegment = styled(Segment)`
  &&& {
    padding: 3rem 3.5rem;
  }
`;

const GridWrapper = styled(Grid)`
  .row {
    padding: 0 !important;
  }

  .row > div {
    padding: 2.5em 0;
  }
`;

const StyledHeader = styled(Header)`
  &&& {
    margin: 0;
    font-size: 1.14em;
    display: inline-flex;
    align-items: center;
  }
`;

const StyledLink = styled(Link)`
  padding-left: 2em;
`;

const StyledAccountValue = styled.div`
  color: #666;
  font-size: 1.2em;
`;
